import Vue from 'vue';
import gsap from 'gsap/all';

/**
 * Do the default transition logic.
 *
 * @param  {JSON} response
 * 
 * @return {void}
 */
export default (response, ctx, router) => {
    // Query the current situation.
    const app = document.getElementById('page-wrapper');
    const current = document.getElementById('page-container');

    // Inject the new page and query it as the ajax template.
    const nextFragment = document.createRange().createContextualFragment(response.data);
    app.appendChild(nextFragment);
    const ajaxTemplate = document.querySelector('.ajax-template');
    current.classList.add('current-page');

    // Rebuild Vue
    router.buildPage(app);

    // Called when the new page has been build by Vue.
    // This is the moment we prepare the new page and run a enter timeline.
    EventBus.$once('page-transition-enter', () => {
        // Switch section.
        document.title = ajaxTemplate.dataset.title || document.title;
        document.body.classList.remove(router.currentSection);
        document.body.classList.add(ajaxTemplate.dataset.namespace);

        window.requestAnimationFrame(() => {
            Vue.nextTick(() => {
                const onEnterStart = () => {
                    gsap.delayedCall(0.7, () => {
                        router.app.toggleNavigation();
                    });
                }

                const onEnterComplete = () => {
                    window.scrollTo(0, 0);
                    router.pageTransitionComplete();
                    document.querySelector('.current-page').remove();
                    document.querySelector('.ajax-template').classList.remove('ajax-template');
                }

                const enterTl = gsap.timeline({ paused: true, onStart: onEnterStart, onComplete: onEnterComplete });

                enterTl.to('.ajax-template', 1.6, { x: '0%', ease: 'power4.inOut' }, 0);
                enterTl.fromTo('.ajax-template .content-wrapper', 1.2, { x: '100%' }, { x: '0%', ease: 'power4.inOut' }, 0.6);
                enterTl.play();
            });
        });
    });
};